import script from "./VirtualAnalyticsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualAnalyticsList.vue?vue&type=script&setup=true&lang=ts"

import "./VirtualAnalyticsList.vue?vue&type=style&index=0&id=206c28ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206c28ad"]])

export default __exports__